import React from "react";
import { Field, reduxForm } from "redux-form";

const requiredID = value => (value ? undefined : "נא להזין מספר תעודת זהות");
const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined;
const IdNumber = value =>
  value && !/^([0-9]{9})$/i.test(value) ? "מספר ת״ז שגוי" : undefined;
const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div className="row" width="100%">
    <div className="col-md-2 col-sm-2 col-xs-2" />
    <div className="col-md-5 col-sm-5 col-xs-5">
      <input {...input} type={type} style={{ direction: "ltr" }} />
    </div>
    <div className="col-md-4 col-sm-4 col-xs-4">
      <label>{label}</label>
    </div>
    <br />
    <div className="col-md-12 col-sm-12 col-xs-12">
      {touched &&
        ((error && (
          <span style={{ color: "red" }}>
            <i>{error}</i>
          </span>
        )) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

const FormSmsID = props => {
  const { handleSubmit, buyer, parcel, submitLabel, price, priceDescription } = props;
  return (
    <form onSubmit={handleSubmit}>
      <br />
      לקוח/ה יקר/ה, בהתאם לתקנות המכס, נדרש מספר תעודת זהות על מנת לשחרר את
      המשלוח שלך
      <hr
        style={{
          backgroundColor: "red",
          height: 1
        }}
      />
      <div>
        <b>פרטי הנמען:</b> {buyer}
      </div>
      <div>
        <b>פרטי החבילה:</b> {parcel}
      </div>
      <hr
        style={{
          backgroundColor: "gray",
          height: 1
        }}
      />
      <div className="row">
        <Field
          name="email"
          type="email"
          component={renderField}
          label="דוא״ל:"
          validate={email}
        />

        <Field
          name="buyerID"
          component={renderField}
          type="text"
          label="* מספר ת״ז:"
          validate={[requiredID, IdNumber]}
        />
        <span style={{ color: "red" }}>
          <i>
            אי הזנת מספר ת״ז, או הזנת מספר ת״ז שגוי עלולה לגרום לעיכוב החבילה
            במכס ולגרור עלויות שחרור ואחסנה נוספות
          </i>
        </span>
        <br />
      </div>
      <br />
      {price && price > 0 ? (
        <div className='sms-content-wrap' style={{ marginBottom: '8px' }}>
          <p className='sms-message'>
            תשלום נדרש עבור {priceDescription}.
            <br />
            עלות: <strong>{price} ש"ח</strong>
          </p>
        </div>
      ) : null}

      <div className='centered'>
        <button className='btn medium orange' type="submit" disabled={!!props.invalid}>{submitLabel || 'אישור'}</button>
      </div>
      <hr
        style={{
          backgroundColor: "gray",
          height: 1
        }}
      />
      כדי למנוע עיכובים במכס וחיוב בדמי אחסנה, יש להזין פרטים בהקדם
    </form>
  );
};

export const ReduxFormSmsID = reduxForm({
  form: "formSmsID" // a unique identifier for this form
})(FormSmsID);
